import React from "react"
import {usePagination, DOTS} from "../../hooks/usePagination"
import {IconContext} from "react-icons/lib"
import {IoChevronBack, IoChevronForward} from "react-icons/io5"

interface PaginationProps {
	onPageChange: (page: any) => void
	totalCount: number
	siblingCount?: number
	currentPage: number
	pageSize: number
	className?: string
}

const Pagination = ({
	onPageChange,
	totalCount,
	siblingCount = 1,
	currentPage,
	pageSize,
	className
}: PaginationProps) => {
	const paginationRange = usePagination({
		currentPage,
		totalCount,
		siblingCount,
		pageSize
	})

	if (currentPage === 0 || paginationRange.length < 2) {
		return null
	}

	const onNext = () => {
		onPageChange(currentPage + 1)
	}

	const onPrevious = () => {
		onPageChange(currentPage - 1)
	}

	let lastPage = paginationRange[paginationRange.length - 1]

	const selectedClass = (classname: string, page: number | string) => {
		if (page === currentPage) return `${classname} ${classname}--selected`
		else return classname
	}

	return (
		<ul className={"pagination-container"}>
			{currentPage === 1 ? (
				<li className={"pagination-item--disabled"}>
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronBack />
					</IconContext.Provider>
				</li>
			) : (
				<li className={"pagination-item"} onClick={onPrevious}>
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronBack />
					</IconContext.Provider>
				</li>
			)}
			{paginationRange.map((pageNumber, idx) => {
				if (pageNumber === DOTS) {
					return (
						<li className='pagination-item dots' key={pageNumber + "" + idx}>
							&#8230;
						</li>
					)
				}

				return (
					<li
						className={selectedClass("pagination-item", pageNumber)}
						onClick={() => onPageChange(pageNumber)}
						key={pageNumber}
					>
						{pageNumber}
					</li>
				)
			})}
			{lastPage === currentPage ? (
				<li className={"pagination-item--disabled"}>
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronForward />
					</IconContext.Provider>
				</li>
			) : (
				<li className={"pagination-item"} onClick={onNext}>
					<IconContext.Provider value={{className: "btn-icon"}}>
						<IoChevronForward />
					</IconContext.Provider>
				</li>
			)}
		</ul>
	)
}

export default Pagination
